import { useEffect } from 'react';

import { createOrUpdateBorrower } from '@/apiCalls/borrower';
import { uniqueIdTransfer } from '@/apiCalls/uniqueIDTransferHelper';
import { EEventType } from '@/components/eventType';
import { getCheapestLender } from '@/utils/getCheapestLender';

import TDRFinance from './TDRFinance/TDRFinance';
import { TDRImage } from './TDRImage';
import { TDRLenderDetails } from './TDRLenderDetails';
import { TDRVehicleDetails } from './TDRVehicleDetails';

export const testId = 'TestDriveReady';

export function TestDriveReady(): JSX.Element {
    // ***** Redux *****
    const lender = getCheapestLender();

    // ***** CONSTANTS *****
    const baseId = 'screen-TestDriveReady';
    const fullScreen = lender === undefined ? true : false;

    void createOrUpdateBorrower();

    // This screen is built from raw divs, not DisplayComponent, so the page
    // view every other screen gets on mount never fired here — and this is the
    // test-drive journey's success screen, whose visibility is what records
    // the 'approved' outcome.
    useEffect(() => {
        uniqueIdTransfer({
            eventType: EEventType.VISIBLE_ON_SCREEN,
            applicationData: { id: `${baseId}-screen` },
        });
    }, []);

    // ***** Render *****
    return (
        <div className='relative w-full h-full' data-testid={testId}>
            <TDRImage fullScreen={fullScreen} />
            <TDRVehicleDetails fullScreen={fullScreen} baseId={baseId} />
            {fullScreen ? (
                <TDRFinance baseId={baseId} />
            ) : (
                <TDRLenderDetails baseId={baseId} />
            )}
        </div>
    );
}
